import React, {FC, useEffect, useState} from "react";
import {OptionType} from "../../types/CommonType";
import {BusinessModel} from "../../models/BusinessModel";
import {BusinessType} from "../../types/BusinessType";
import Async from "react-select/async";
import clsx from "clsx";
import { FormattedMessage, useIntl } from "react-intl";
import { LANG_COMMON_ALL, LANG_COMMON_CHOOSE } from "../../lang";
import { useAPI } from "../../hooks/useAPI";

interface Props {
    onChange: (business_id: number | undefined) => void
    isValid?: boolean
    isTouched?: boolean
    planId?: string | number
}
const PlanSelect: FC<Props> = ({onChange, isTouched=undefined, isValid=undefined, planId=undefined}) => {
    const [defaultValue, setDefaultValue] = useState<OptionType | null>(null);
    const { api } = useAPI();

    const loadPlans = async (inputValue: string) => {
        return new Promise<Array<any>>((resolve) => {
            api().get('/api/plan/master').then((resp) => {
                if(typeof resp.data !== "boolean") {
                    resolve(resp.data);
                    updateDefaultValue(resp.data);
                } else {
                    resolve([]);
                }
            });
        });
    }

    const updateDefaultValue = (planList: Array<any>) => {
        let item: any;
        let i: any;
        for(i in planList) {
            item = planList[i];
            if(item.id.toString() === planId?.toString()) {
                setDefaultValue({label: item.name, value: item.id});
            }
        }
    }

    const intl = useIntl();

    return (
        <Async
            value={defaultValue}
            className={clsx("react-select-container", {
                "is-invalid": isTouched && !isValid,
                "is-valid": isTouched && isValid
            })}
            classNamePrefix={'react-select'}
            placeholder={`${intl.formatMessage(LANG_COMMON_ALL)}`}
            isSearchable={true}
            defaultOptions={true}
            isClearable={true}
            onChange={(selectedOption: OptionType | null) => {
                setDefaultValue(selectedOption);
                onChange((selectedOption !== null) ? selectedOption.value : undefined);
            }}
            loadOptions={(inputValue, callback) => {
                loadPlans(inputValue).then((planList) => {
                    callback(planList.map((item: any) => {
                        return {label: item.name, value: item.id};
                    }));
                });
            }}
        />
    );
}

export default PlanSelect;